'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import CardEmailIcon from '@/Icons/CardEmailIcon'
import CardReadIcon  from '@/Icons/CardReadIcon'

import Image from '@Pure/Image'

import { num } from '@root/utility'

const moment = window.moment;

let app = window.app;

export default class UserCard extends Component
{
	state =
	{
		id: '',
		name: 'Nom prénom',
		company: 'Votre CE'
	};

	componentDidMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange('componentDidMount');
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = (source) =>
	{
		const component = this, props = this.props, state = this.state;

		if (!app.state.session.EC) return;

		component.setState(
		{
			name: app.state.session.firstname + ' ' + app.state.session.lastname,
			company: app.state.session.EC.company,
			id: app.state.session.id
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let card_verso;

		if (component.state.company)
		{
			card_verso =
			(
				<div className={ 'c-synergies-card ' + (props.className || '') +
					' verso' }>

					<div className="c-synergies-card__data">

						<div className="c-synergies-card__company">
							<div className="c-synergies-card__company-label">
								Structure
								<br />
								Adhérente
							</div>
							{ state.company }
						</div>

						<div className="c-synergies-card__name">
							<div className="c-synergies-card__name-label">
								Titulaire
							</div>
							{ state.name }
						</div>

						<div className="c-synergies-card__usage">

							<div className="c-synergies-card__usage-label">
								Pour bénéficier de tous vos avantages, créez votre compte
							</div>

							<div className="c-synergies-card__usage-txt">

								<div className="c-synergies-card__usage-row">
									<CardEmailIcon
										className="c-synergies-card__icon"
									/>
									Envoyez un mail à <strong>contact@e-synergies.fr</strong>
									<br />
									(Précisez le nom de votre structure adhérente)
								</div>

								<div className="c-synergies-card__usage-row">
									<CardReadIcon
										className="c-synergies-card__icon"
									/>
									Vous recevrez vos identifiants de connexion par mail.
								</div>

							</div>

						</div>

						<div className="c-synergies-card__infos">
							<div className="c-synergies-card__validity">
								Date de validité&nbsp;:
								{ ' ' }
								{
									moment().startOf('year')
									.add(360, 'days')
									.add(1, 'month')
									.endOf('month')
									.format('DD/MM/YYYY')
								}
							</div>

							<div className="c-synergies-card__warn">
								Carte individuelle, ne peux être cédée.
							</div>
						</div>

					</div>

				</div>
			);
		}

		const recto_filename = num(moment().format('YYYY'), 0) > 2025
		? 'carte_synergies_2026.png'
		: 'carte_synergies_2025_recto.jpg';

		return (
			<div className="u-full-width u-flex u-flex-wrap
				u-content-center u-items-stretch">

				<div className={ 'c-synergies-card ' + (props.className || '') +
				' recto' }>

					<Image src={ '/images/' + recto_filename } />

					<div className="c-synergies-card__recto-txt">
						ADHÉRENT
						{ ' ' }
						{ moment().format('YYYY') }
					</div>

				</div>

				{ card_verso }

			</div>
		);
	}
}